import { Controller } from "@hotwired/stimulus";

// walk/HOME.md § The fold opens the page.
//
// The fold is a link to the sign-in page. This turns it into a peel on the same page:
// the wrapper gets data-peeled, CSS grows --fold, and the back of the page is
// revealed from the corner. No JavaScript, no peel — the link still goes
// where it says.
export default class extends Controller {
  static targets = ["fold", "back"];

  open(event) {
    event.preventDefault();
    this.element.dataset.peeled = "";
    this.backTarget.inert = false;
    this.under(true);
    this.foldTarget.setAttribute("aria-expanded", "true");
    // Focus on the card's first visible control, so a keyboard is already
    // there — the passkey, not the toggle the email form folds behind.
    [
      ...this.backTarget.querySelectorAll(
        "a[href], button, input:not([type=hidden])",
      ),
    ]
      .find((el) => el.checkVisibility() && el.tabIndex >= 0)
      ?.focus({ preventScroll: true });
    this.onKey = (e) => e.key === "Escape" && this.close();
    document.addEventListener("keydown", this.onKey);
  }

  close(event) {
    event?.preventDefault();
    delete this.element.dataset.peeled;
    this.backTarget.inert = true;
    this.under(false);
    this.foldTarget.setAttribute("aria-expanded", "false");
    document.removeEventListener("keydown", this.onKey);
    this.foldTarget.focus({ preventScroll: true });
  }

  // What the back covers — the page, its foot, and the fold under the flap —
  // is inert while it is open, so Tab never walks under it.
  under(inert) {
    for (const el of [
      ...document.querySelectorAll("body > main, body > footer"),
      this.foldTarget,
    ])
      el.inert = inert;
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey);
  }
}
